document.addEventListener('DOMContentLoaded', () => {
  $(document).on(`click`, `.collection-faqs .item-title`, function () {
    if ($(this).siblings('.item-desc').is(':hidden')) {
      $(this).find('.toggle-btn').html(`-`);
      $(this).addClass('active');
    } else {
      $(this).find('.toggle-btn').html('+');
      $(this).removeClass('active');
    }
    $(this).siblings('.item-desc').slideToggle();
  });

  // $(`.collection-faqs .item-title`).eq(0).click();  // 默认第一项展开

  // 标题主体键盘控制折叠
  // $(document).on(`keydown`, `.collection-faqs .item-title`, function (e) {
  //   if(e.key == 'Enter' || e.key == ' '){
  //     e.preventDefault(); // 若要触发空格键事件，且不触发空格导致的页面滚动默认事件
  //     e.stopPropagation(); // 阻止事件冒泡
  //     $(this).click();
  //   }
  // });
});